import React from 'react'
import {graphql, useStaticQuery} from 'gatsby'
import {Helmet} from 'react-helmet'

function SEO({title, seo, slug}) {
    const {
        site: {siteMetadata},
    } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          description
          keywords
          title
        }
      }
    }
  `)
    
    const toUrl = (url) => {
        if (url && url.startsWith("http"))
            return url.replace("https:", "").replace("http:", "")
        return url;
    }
    
    const defaultTitle = siteMetadata.title
    
    const pageDescription = seo?.description || siteMetadata.description
    const pageKeywords = seo?.keywords || siteMetadata.keywords
    const pageTitle = seo?.title || title || 'Home'
    let pageUrl = toUrl(seo?.url || `https://www3.rev-lock.com/posts/${slug}`)
    let imageUrl = toUrl(seo && seo.image && seo.image.url ? seo.image.url : null);
    
    
    return (
       <Helmet
          htmlAttributes={{lang: 'en'}}
          defaultTitle={defaultTitle}
          titleTemplate={`%s | ${defaultTitle}`}>
           <title>{pageTitle}</title>
           <link rel="shortcut icon" href="https://s3.amazonaws.com/content.rev-lock.com/images/favicon.ico"/>
           <meta name="description" content={pageDescription}/>
           <meta name="keywords" content={pageKeywords}/>
           {imageUrl && <meta property="image" content={imageUrl}/>}
           
           <meta property="og:url" content={pageUrl}/>
           <meta property="og:title" content={pageTitle}/>
           <meta property="og:description" content={pageDescription}/>
           <meta property="og:site_name" content={defaultTitle}/>
           {imageUrl && <meta property="og:image" content={imageUrl}/>}
           <meta name="og:type" content="website"/>
           
           <meta name="twitter:site" content="@GraphCMS"/>
           <meta name="twitter:title" content={`${pageTitle} | ${defaultTitle}`}/>
           <meta name="twitter:card" content="summary_large_image"/>
           {imageUrl && <meta name="twitter:image:src" content={imageUrl}/>}
       </Helmet>
    )
}

export default SEO
